// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconGift = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 3.528l-.06-.078A3.65 3.65 0 009 2c-.99 0-1.795.342-2.33.985C6.16 3.595 6 4.35 6 5c0 .885.431 1.586.925 2.147.253.286.553.57.872.853H4v6h1v7h14v-7h1V8h-3.797c.32-.282.62-.567.872-.853C17.569 6.586 18 5.885 18 5c0-.649-.16-1.404-.67-2.015C16.796 2.342 15.99 2 15 2a3.65 3.65 0 00-2.94 1.45zm1.64 1.147C13.277 5.144 13 5.91 13 7v1h.096c.137-.128.25-.225.355-.31l.003-.003.018-.015.078-.062.477-.382.128-.109c.617-.52 1.084-.914 1.419-1.294C15.92 5.432 16 5.188 16 5c0-.351-.09-.596-.206-.735C15.705 4.158 15.51 4 15 4c-.551 0-1.012.227-1.36.675M11 8V7c0-1.09-.277-1.856-.64-2.325C10.012 4.227 9.551 4 9 4c-.51 0-.705.158-.794.265C8.09 4.405 8 4.65 8 5c0 .188.08.432.426.825.335.38.802.774 1.419 1.294l.138.117c.13.11.239.195.345.278.173.136.339.266.576.486zm0 2H6v2h5zm2 0v2h5v-2zm-2 9v-5H7v5zm2 0v-5h4v5z"
    />
  );
export default SvgIconGift;
